import { Select } from "@mantine/core";
import { ComponentProps, forwardRef, memo, Ref } from "react";

export type InputSelectProps = ComponentProps<typeof Select> & {};

//! SELECT
function InputSelectComponent(props: InputSelectProps, ref: Ref<HTMLInputElement>) {
  return <Select data={[]} limit={50} ref={ref} searchable {...props} />;
}

export const InputSelect = memo(forwardRef(InputSelectComponent));
InputSelect.displayName = "InputSelect";
